import { useTranslation } from 'react-i18next';
import { Modal, Form} from 'react-bootstrap';
import { StyledRefundModal } from './RefundModal.styled';

const DeleteModal = ({ show, onHide, rowToDelete, currentRadio, onRadioChange, onDeleteClick }) => {
    const { t } = useTranslation();
    const isRecurring = rowToDelete && (rowToDelete.isRecurring || rowToDelete.original?.isRecurring) === 'yes'

    return (
        <StyledRefundModal
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header>
                <Modal.Title>{t('reports.delete.modalTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isRecurring && (
                    <>
                        <Form>
                            <Form.Check
                                id="one"
                                type="radio"
                                label={t('reports.delete.radioLabels.onePayment')}
                                value="one"
                                name="deletePending"
                                onChange={onRadioChange}
                                checked={currentRadio === 'one'}
                            />
                            <Form.Check
                                id="all"
                                type="radio"
                                label={t('reports.delete.radioLabels.allPayments')}
                                value="all"
                                name="deletePending"
                                onChange={onRadioChange}
                                checked={currentRadio === 'all'}
                            />
                            <Form.Check
                                id="allNext"
                                type="radio"
                                label={t('reports.delete.radioLabels.allNextPayments')}
                                value="allNext"
                                name="deletePending"
                                onChange={onRadioChange}
                                checked={currentRadio === 'allNext'}
                            />
                        </Form>
                    </>
                )}
                <div className="buttons-container">
                    <button
                        className="bllink-button"
                        onClick={onDeleteClick}
                    >
                        {t('reports.delete.btns.confirm')}
                    </button>

                    <button
                        onClick={onHide}
                        className="btn_12"
                    >
                        {t('reports.delete.btns.cancel')}
                    </button>
                </div>
            </Modal.Body>
        </StyledRefundModal>
    );
};

export default DeleteModal;
